import { achievementResourceType } from "@/modules/achievements/api/achievementResourceConsts";
import { GetRankingResponse } from "@/modules/ranking/api/queries/getRankingQuery";

type ParsedUser = {
  name: string;
  points: number;
  id: string;
};

export function parseRankingResponse(response: GetRankingResponse) {
  const { data, included } = response;

  const usersAchievements = included.filter(
    (responseItem) => responseItem.type === achievementResourceType
  );

  const parsedUsers = data.map((user) => {
    const userAchievementsIds = user.relationships.userGroupAchievements.data.map(
      ({ id }) => id
    );

    const userAchievements = usersAchievements.filter((achievement) =>
      userAchievementsIds.includes(achievement.id)
    );

    return {
      name: `${user.attributes.firstName} ${user.attributes.lastName}`,
      points: userAchievements[0].attributes.pointsNumber,
      id: user.id,
    };
  });

  const usersGroupedByPointsNumber = parsedUsers.reduce(
    (group: Record<number, Array<ParsedUser>>, user) => {
      const { points } = user;
      group[points] = group[points] ?? [];

      group[points].push(user);
      return group;
    },
    {}
  );

  const orderedGroups = Object.keys(usersGroupedByPointsNumber)
    .sort((a, b) => Number(b) - Number(a))
    .map((points) => {
      return usersGroupedByPointsNumber[Number(points)];
    });

  const orderedUsers = orderedGroups.flatMap((exAequoUsers, index) => {
    return exAequoUsers.map((user) => ({ ...user, place: index + 1 }));
  });

  return orderedUsers;
}
